// eslint-disable-next-line @tseslint/typedef
export const OVERVIEW_HEADER_OPERATOR_STRATEGY = {
  /** Emits that the operator was clicked */
  emit: "emit",
  /** When clicked an operator automatically does it's action  */
  handle: "handle"
} as const;
export type OverviewHeaderOperatorStrategy = typeof OVERVIEW_HEADER_OPERATOR_STRATEGY[keyof typeof OVERVIEW_HEADER_OPERATOR_STRATEGY];
